import script from "./StatusLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusLabel.vue?vue&type=script&setup=true&lang=js"

import "./StatusLabel.vue?vue&type=style&index=0&id=44df61c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44df61c4"]])

export default __exports__